const options = {
  5: "bg-stone-900/5",
  10: "bg-stone-900/10",
  25: "bg-stone-900/25",
  50: "bg-stone-900/50",
  75: "bg-stone-900/75",
  90: "bg-stone-900/90",
  100: "bg-stone-900",
};

const from = {
  5: "from-stone-900/5",
  10: "from-stone-900/10",
  25: "from-stone-900/25",
  50: "from-stone-900/50",
  75: "from-stone-900/75",
  90: "from-stone-900/90",
  100: "from-stone-900",
};

export default function getBackgroundStone900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
